import React, { ButtonHTMLAttributes, FC } from 'react';
import styled from '@xstyled/styled-components';
import { x } from '@xstyled/styled-components';
import PauseIcon from '~/assets/icons/pause.svg';
import LockIcon from '~/assets/icons/white_lock1.svg';
import { drillAnimation } from '~/ui/animation';
import { TrainingState, useTrainingStore } from '~/training/state';
import { select } from '~/lib/select';

const Button = styled.button`
  background: ${p => p.theme.colors.accentDark};
  padding: 14px;
  min-width: 50px;
  height: 50px;
  border-radius: 25px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const DrillBoxAnimation = styled.div`
  width: 60px;
  height: 60px;
  animation: ${drillAnimation} 2.3s ease infinite;
  position: absolute;
  background-color: accentDark;
  border-radius: 50%;
  z-index: -1;
  opacity: 0.5;
`;

const selectorVisualFeedback = (s: TrainingState) =>
  select(s, 'visualFeedback');

type LockWrapperProps = {
  number?: number | string;
};

const LockWrapper: React.FC<LockWrapperProps> = ({ number }) => {
  const { visualFeedback } = useTrainingStore(selectorVisualFeedback);
  return (
    <>
      {number ? <x.span color="#FFF">{number}</x.span> : <LockIcon />}
      {visualFeedback && <DrillBoxAnimation />}
    </>
  );
};

export const Pause = styled(PauseIcon)``;

export const LockButton: FC<
  ButtonHTMLAttributes<HTMLButtonElement> & {
    progress?: number;
    number?: number | string;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
> = ({ children, number, ...props }) => {
  return (
    <Button {...props} as={'div' as never}>
      <LockWrapper number={number} />
    </Button>
  );
};
